import React from 'react';
import { useRouter } from 'next/router';
import { ORIGIN } from 'src/constants';

import shareIconV2 from '../public/images/shareV2.svg';
import HeaderButton from 'components/HeaderButton';
import useSnackbar from 'components/SnackBar/useSnackbar';

const ShareButtonV2: React.FC<{
  h?: number;
  w?: number;
  labelClassName?: string;
  gapClassName?: string;
}> = ({ h, w, labelClassName, gapClassName }) => {
  const { showSuccess } = useSnackbar();
  const router = useRouter();
  const handleShare = () => {
    navigator.clipboard.writeText(`${ORIGIN}${router.asPath}`);
    showSuccess({ message: 'Link copied' });
  };
  return (
    <HeaderButton
      icon={shareIconV2}
      alt="share"
      label="Share"
      onClick={handleShare}
      tooltip="Share"
      iconHeight={h}
      iconWidth={w}
      labelClassName={labelClassName}
      gapClassName={gapClassName}
    />
  );
};

export default ShareButtonV2;
